import { Button } from '@/components/ui/button';
import { type SanityCategory } from '@/lib/sanity';
import { cn } from '@/lib/utils';

interface CategoryFilterProps {
  categories: SanityCategory[];
  selectedCategory: string | null;
  onSelectCategory: (slug: string | null) => void;
}

export function CategoryFilter({ 
  categories, 
  selectedCategory, 
  onSelectCategory 
}: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant={selectedCategory === null ? 'default' : 'outline'}
        size="sm"
        onClick={() => onSelectCategory(null)}
        className={cn(
          "rounded-full",
          selectedCategory === null && "bg-primary text-primary-foreground"
        )}
      >
        All
      </Button>
      {categories.map((category) => (
        <Button
          key={category._id}
          variant={selectedCategory === category.slug.current ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSelectCategory(category.slug.current)}
          className={cn(
            "rounded-full",
            selectedCategory === category.slug.current && "bg-primary text-primary-foreground"
          )}
        >
          {category.title}
        </Button>
      ))}
    </div>
  );
}
